import { render, staticRenderFns } from "./FixedList.vue?vue&type=template&id=5757e8dc&scoped=true"
import script from "./FixedList.vue?vue&type=script&lang=js"
export * from "./FixedList.vue?vue&type=script&lang=js"
import style0 from "./FixedList.vue?vue&type=style&index=0&id=5757e8dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5757e8dc",
  null
  
)

export default component.exports